import React from 'react';

type ErrorBoundaryState = { hasError: boolean; error?: any };

type ErrorBoundaryProps = { children: React.ReactNode };

export class CustPortalErrorBoundary extends React.Component<ErrorBoundaryProps, ErrorBoundaryState> {
	constructor(props: ErrorBoundaryProps) {
		super(props);
		this.state = { hasError: false };
	}

	static getDerivedStateFromError(error: any): ErrorBoundaryState {
		return { hasError: true, error };
	}

	componentDidCatch(error: any, errorInfo: any) {
		if (process.env.NODE_ENV !== 'production') {
			// eslint-disable-next-line no-console
			console.error('[custportal] Uncaught render error', { error, errorInfo });
		}
	}

	render() {
		if (this.state.hasError) {
			if (process.env.NODE_ENV !== 'production') {
				return (
					<div style={{ padding: 16 }}>
						<h2>Customer portal crashed</h2>
						<pre style={{ whiteSpace: 'pre-wrap', color: '#b91c1c' }}>{String(this.state.error)}</pre>
						<p>Check the console for a stack trace.</p>
					</div>
				);
			}
			return (
				<div style={{ padding: 16 }}>
					<h2>Something went wrong</h2>
					<p>Please try again later.</p>
				</div>
			);
		}
		return this.props.children as any;
	}
} 